import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function fetchDropboxUserMemberships(dropboxId, userId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/dropboxes/${dropboxId}/users/${userId}/memberships`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function fetchAssignmentMemberships(assignmentId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments/${assignmentId}/memberships`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function fetchSubmissionMemberships(submissionId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/submissions/${submissionId}/memberships`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function deleteSubmissionMembership(membershipId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/memberships/${membershipId}`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "DELETE";

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}




/** WEBPACK FOOTER **
 ** ./src/connectivity/api.memberships.js
 **/